import { Avatar, Button, Col, Row } from "antd";
import { useCallback, useState } from "react";
import Draggable from "react-draggable";
import { FaVideo } from "react-icons/fa";
import { MdCall, MdCallEnd } from "react-icons/md";
import callingMusic from "../../../assets/waiting-music.mp3";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { useInfoUser } from "../../../store/UserStore";
import { getAvatar, getColor, getColorFromInitial } from "../../../utils/Utils";
import "./style.scss";

const CURRENT_WEB =
  process.env.REACT_APP_CURRENT_WEB || "https://winitech.com.vn:3007";

const SmallInComingCall = ({ open, onCancel, onClose }) => {
  const { user, languageMap } = useInfoUser();
  const { friend, callingId } = useAuthLayoutContext();
  const [isLoading, setIsLoading] = useState(false);
  // const [friend, setFriend] = useState(null);

  // const {callWindowRef} = useCallingContext()

  const openCallWindow = useCallback(
    (mode) => {
      const width = 1250;
      const height = 700;

      // Calculate the position to center the window
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;

      // Open the popup
      window.open(
        CURRENT_WEB +
          "/calling?caller_id=" +
          friend?.userId +
          "&mode=" +
          mode +
          "&calling_id=" +
          callingId,
        "_blank",
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=no`
      );

      onCancel();
    },
    [friend]
  );

  return (
    <Draggable bounds="parent">
      <div className="absolute bottom-[100px] right-[50px] bg-[#2a56b9] text-white rounded-[10px] cursor-grabbing z-[99999] shadow-lg">
        <audio src={callingMusic} preload="auto" autoPlay />

        <Row className="pt-[10px] w-[100%]">
          <Col span={3}></Col>
          <Col span={18} className="text-[16px] font-semibold text-center">
            {languageMap?.["call.incoming"] ?? "Incoming call"}
          </Col>
          <Col span={3} className="flex justify-end pr-[20px]">
            {/* <Button
            type="default"
            className="border-none bg-[#387ef3]"
            icon={<BiCollapse className="text-[22px] !text-white" />}
            onClick={() => setIsCollapse(false)}
          /> */}
          </Col>
        </Row>
        <div className="general-modal pb-[10px] px-[70px]">
          <div className="flex flex-col items-center justify-between">
            <Avatar
              style={{
                backgroundColor: getColorFromInitial(
                  friend?.name?.[0] || friend?.username?.[0]
                ),
                color: getColor(friend?.name?.[0] || friend?.username?.[0]),
              }}
              // className="animated-avatar"
              size={70}
              src={friend?.avatar ? getAvatar(friend) : null}
            >
              {friend?.name?.[0] || friend?.username?.[0]}
            </Avatar>
            <div className="text-[18px] font-bold mt-[10px]">
              {friend?.name}
            </div>
            <div className="text-[16px] font-semibold">
              {languageMap?.["call.incoming"] ?? "is calling to you"}
            </div>

            <div className="flex gap-[50px] mt-[30px]">
              <Button
                type="default"
                shape="circle"
                className="bg-[#37b361] text-[white]"
                size="large"
                icon={<FaVideo className="text-[22px]" />}
                onClick={() => openCallWindow("video")}
              />
              <Button
                type="default"
                shape="circle"
                className="bg-[#37b361] text-[white] shake-up-down"
                size="large"
                icon={<MdCall className="text-[22px]" />}
                onClick={() => openCallWindow("audio")}
              />
              <Button
                type="default"
                shape="circle"
                className="bg-[red] text-[white]"
                size="large"
                icon={<MdCallEnd className="text-[22px]" />}
                onClick={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
};

export default SmallInComingCall;
